module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousams
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Importer Security Filing(ISF)")])], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.amsFiligModal.normalIsfId != '') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.downloadWord()
      }
    }
  }, [_vm._v("ISF Word")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.stuffingDataLiner[0].allModuleId,
      "jobSeriesBanner": this.stuffingDataLiner[0].ffExportFclSeries,
      "bannerClientName": this.getCLientData[0].clientName,
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientId",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name",
      "isDisabled": ""
    },
    model: {
      value: (_vm.amsFiligModal.clientId),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "clientId", $$v)
      },
      expression: "amsFiligModal.clientId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Seller/Shipper Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shipperName",
      "name": "shipperName"
    },
    model: {
      value: (_vm.amsFiligModal.shipperName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "shipperName", $$v)
      },
      expression: "amsFiligModal.shipperName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tel/ Fax")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shipperTelFax",
      "name": "shipperTelFax"
    },
    model: {
      value: (_vm.amsFiligModal.shipperTelFax),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "shipperTelFax", $$v)
      },
      expression: "amsFiligModal.shipperTelFax"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Street Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shipperAddrs",
      "name": "shipperAddrs"
    },
    model: {
      value: (_vm.amsFiligModal.shipperAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "shipperAddrs", $$v)
      },
      expression: "amsFiligModal.shipperAddrs"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("City / Postal Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cityPostalCode",
      "name": "cityPostalCode"
    },
    model: {
      value: (_vm.amsFiligModal.cityPostalCode),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "cityPostalCode", $$v)
      },
      expression: "amsFiligModal.cityPostalCode"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shipperCountry",
      "name": "shipperCountry"
    },
    model: {
      value: (_vm.amsFiligModal.shipperCountry),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "shipperCountry", $$v)
      },
      expression: "amsFiligModal.shipperCountry"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Manufracturer( Or Suppliers) Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "manufracturer"
    }
  }, [_vm._v("Manufracturer(Suppliers)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.manufracturerList,
      "id": "manufracturer",
      "option-value": "manufracturerVal",
      "option-text": "manufracturerTxt",
      "placeholder": "Select Manufracturer",
      "isDisabled": _vm.amsFiligModal.blType == 'liner'
    },
    model: {
      value: (_vm.amsFiligModal.manufracturer),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "manufracturer", $$v)
      },
      expression: "amsFiligModal.manufracturer"
    }
  })], 1)], 1), _vm._v(" "), (_vm.amsFiligModal.manufracturer != 'Others' && _vm.amsFiligModal.manufracturer != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.amsFiligModal.manufacturerLabel))]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.manufacturerAll),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "manufacturerAll", $$v)
      },
      expression: "amsFiligModal.manufacturerAll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.manufracturer == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manuOtherName",
      "name": "manuOtherName"
    },
    model: {
      value: (_vm.amsFiligModal.manuOtherName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "manuOtherName", $$v)
      },
      expression: "amsFiligModal.manuOtherName"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.manufracturer == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Street Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manuOthersAddrs",
      "name": "manuOthersAddrs"
    },
    model: {
      value: (_vm.amsFiligModal.manuOthersAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "manuOthersAddrs", $$v)
      },
      expression: "amsFiligModal.manuOthersAddrs"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.manufracturer == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("City / Postal Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manuOthersCityPostal",
      "name": "manuOthersCityPostal"
    },
    model: {
      value: (_vm.amsFiligModal.manuOthersCityPostal),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "manuOthersCityPostal", $$v)
      },
      expression: "amsFiligModal.manuOthersCityPostal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manuOthersCountrt",
      "name": "manuOthersCountrt"
    },
    model: {
      value: (_vm.amsFiligModal.manuOthersCountrt),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "manuOthersCountrt", $$v)
      },
      expression: "amsFiligModal.manuOthersCountrt"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tel/ Fax")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manuOthersTelFax",
      "name": "manuOthersTelFax"
    },
    model: {
      value: (_vm.amsFiligModal.manuOthersTelFax),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "manuOthersTelFax", $$v)
      },
      expression: "amsFiligModal.manuOthersTelFax"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Importer Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "Importer"
    }
  }, [_vm._v("Importer")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.manufracturerList,
      "id": "Importer",
      "option-value": "manufracturerVal",
      "option-text": "manufracturerTxt",
      "placeholder": "Select Importer",
      "isDisabled": _vm.amsFiligModal.blType == 'liner'
    },
    model: {
      value: (_vm.amsFiligModal.ImporterInfo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "ImporterInfo", $$v)
      },
      expression: "amsFiligModal.ImporterInfo"
    }
  })], 1)], 1), _vm._v(" "), (_vm.amsFiligModal.ImporterInfo != 'Others' && _vm.amsFiligModal.ImporterInfo != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.amsFiligModal.importerLabel))]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.importerAll),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "importerAll", $$v)
      },
      expression: "amsFiligModal.importerAll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.ImporterInfo == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "impOtherName",
      "name": "impOtherName"
    },
    model: {
      value: (_vm.amsFiligModal.impOtherName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "impOtherName", $$v)
      },
      expression: "amsFiligModal.impOtherName"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.ImporterInfo == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Street Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "impOthersAddrs",
      "name": "impOthersAddrs"
    },
    model: {
      value: (_vm.amsFiligModal.impOthersAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "impOthersAddrs", $$v)
      },
      expression: "amsFiligModal.impOthersAddrs"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.ImporterInfo == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("City / Postal Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "impOthersCityPostal",
      "name": "impOthersCityPostal"
    },
    model: {
      value: (_vm.amsFiligModal.impOthersCityPostal),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "impOthersCityPostal", $$v)
      },
      expression: "amsFiligModal.impOthersCityPostal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "impOthersCountrty",
      "name": "impOthersCountry"
    },
    model: {
      value: (_vm.amsFiligModal.impOthersCountry),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "impOthersCountry", $$v)
      },
      expression: "amsFiligModal.impOthersCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tel/ Fax")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "impOthersTelFax",
      "name": "impOthersTelFax"
    },
    model: {
      value: (_vm.amsFiligModal.impOthersTelFax),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "impOthersTelFax", $$v)
      },
      expression: "amsFiligModal.impOthersTelFax"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Buyer Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "Buyer"
    }
  }, [_vm._v("Buyer")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.manufracturerList,
      "id": "Buyer",
      "option-value": "manufracturerVal",
      "option-text": "manufracturerTxt",
      "placeholder": "Select Buyer",
      "isDisabled": _vm.amsFiligModal.blType == 'liner'
    },
    model: {
      value: (_vm.amsFiligModal.BuyerInfo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "BuyerInfo", $$v)
      },
      expression: "amsFiligModal.BuyerInfo"
    }
  })], 1)], 1), _vm._v(" "), (_vm.amsFiligModal.BuyerInfo != 'Others' && _vm.amsFiligModal.BuyerInfo != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.amsFiligModal.buyerLabel))]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.buyerAll),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "buyerAll", $$v)
      },
      expression: "amsFiligModal.buyerAll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.BuyerInfo == 'Others') ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyerrName",
      "name": "buyerrName"
    },
    model: {
      value: (_vm.amsFiligModal.buyerrName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "buyerrName", $$v)
      },
      expression: "amsFiligModal.buyerrName"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.amsFiligModal.BuyerInfo == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Street Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyerOthersAddrs",
      "name": "buyerOthersAddrs"
    },
    model: {
      value: (_vm.amsFiligModal.buyerOthersAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "buyerOthersAddrs", $$v)
      },
      expression: "amsFiligModal.buyerOthersAddrs"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.BuyerInfo == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("City / Postal Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyerOthersCityPostal",
      "name": "buyerOthersCityPostal"
    },
    model: {
      value: (_vm.amsFiligModal.buyerOthersCityPostal),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "buyerOthersCityPostal", $$v)
      },
      expression: "amsFiligModal.buyerOthersCityPostal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyerOthersCountry",
      "name": "buyerOthersCountry"
    },
    model: {
      value: (_vm.amsFiligModal.buyerOthersCountry),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "buyerOthersCountry", $$v)
      },
      expression: "amsFiligModal.buyerOthersCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tel/ Fax")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyerOthersTelFax",
      "name": "buyerOthersTelFax"
    },
    model: {
      value: (_vm.amsFiligModal.buyerOthersTelFax),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "buyerOthersTelFax", $$v)
      },
      expression: "amsFiligModal.buyerOthersTelFax"
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Consignee Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "Buyer"
    }
  }, [_vm._v("Consignee")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.manufracturerList,
      "id": "Buyer",
      "option-value": "manufracturerVal",
      "option-text": "manufracturerTxt",
      "placeholder": "Select Consignee",
      "isDisabled": _vm.amsFiligModal.blType == 'liner'
    },
    model: {
      value: (_vm.amsFiligModal.consigneeInfo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consigneeInfo", $$v)
      },
      expression: "amsFiligModal.consigneeInfo"
    }
  })], 1)], 1), _vm._v(" "), (_vm.amsFiligModal.consigneeInfo != 'Others' && _vm.amsFiligModal.consigneeInfo != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.amsFiligModal.consigneeLabel))]), _vm._v(" "), _c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.amsFiligModal.consigneeAll),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consigneeAll", $$v)
      },
      expression: "amsFiligModal.consigneeAll"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.consigneeInfo == 'Others') ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "conName",
      "name": "conName"
    },
    model: {
      value: (_vm.amsFiligModal.conName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "conName", $$v)
      },
      expression: "amsFiligModal.conName"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.amsFiligModal.consigneeInfo == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Street Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consigneeOthersAddrs",
      "name": "consigneeOthersAddrs"
    },
    model: {
      value: (_vm.amsFiligModal.consigneeOthersAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consigneeOthersAddrs", $$v)
      },
      expression: "amsFiligModal.consigneeOthersAddrs"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.amsFiligModal.consigneeInfo == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("City / Postal Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consigneeOthersCityPostal",
      "name": "consigneeOthersCityPostal"
    },
    model: {
      value: (_vm.amsFiligModal.consigneeOthersCityPostal),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consigneeOthersCityPostal", $$v)
      },
      expression: "amsFiligModal.consigneeOthersCityPostal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consigneeOthersCountry",
      "name": "consigneeOthersCountry"
    },
    model: {
      value: (_vm.amsFiligModal.consigneeOthersCountry),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consigneeOthersCountry", $$v)
      },
      expression: "amsFiligModal.consigneeOthersCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tel/ Fax")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consigneeOthersTelFax",
      "name": "consigneeOthersTelFax"
    },
    model: {
      value: (_vm.amsFiligModal.consigneeOthersTelFax),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consigneeOthersTelFax", $$v)
      },
      expression: "amsFiligModal.consigneeOthersTelFax"
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Consolidator Or Booking Agent Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorName",
      "name": "consolidatorName"
    },
    model: {
      value: (_vm.amsFiligModal.consolidatorName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consolidatorName", $$v)
      },
      expression: "amsFiligModal.consolidatorName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Street Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorAddrs",
      "name": "consolidatorAddrs"
    },
    model: {
      value: (_vm.amsFiligModal.consolidatorAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consolidatorAddrs", $$v)
      },
      expression: "amsFiligModal.consolidatorAddrs"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("City / Postal Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorCityPostal",
      "name": "consolidatorCityPostal"
    },
    model: {
      value: (_vm.amsFiligModal.consolidatorCityPostal),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consolidatorCityPostal", $$v)
      },
      expression: "amsFiligModal.consolidatorCityPostal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorCountry",
      "name": "consolidatorCountry"
    },
    model: {
      value: (_vm.amsFiligModal.consolidatorCountry),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consolidatorCountry", $$v)
      },
      expression: "amsFiligModal.consolidatorCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tel/ Fax")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorTelFax",
      "name": "consolidatorTelFax"
    },
    model: {
      value: (_vm.amsFiligModal.consolidatorTelFax),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consolidatorTelFax", $$v)
      },
      expression: "amsFiligModal.consolidatorTelFax"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Stuffing Location Details")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorName",
      "name": "consolidatorName"
    },
    model: {
      value: (_vm.amsFiligModal.containerStuffingName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerStuffingName", $$v)
      },
      expression: "amsFiligModal.containerStuffingName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Street Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorAddrs",
      "name": "consolidatorAddrs"
    },
    model: {
      value: (_vm.amsFiligModal.containerStuffingAddrs),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerStuffingAddrs", $$v)
      },
      expression: "amsFiligModal.containerStuffingAddrs"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("City / Postal Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorCityPostal",
      "name": "consolidatorCityPostal"
    },
    model: {
      value: (_vm.amsFiligModal.containerStuffingCityPostal),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerStuffingCityPostal", $$v)
      },
      expression: "amsFiligModal.containerStuffingCityPostal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorCountry",
      "name": "consolidatorCountry"
    },
    model: {
      value: (_vm.amsFiligModal.containerStuffingCountry),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerStuffingCountry", $$v)
      },
      expression: "amsFiligModal.containerStuffingCountry"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tel/ Fax")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidatorTelFax",
      "name": "consolidatorTelFax"
    },
    model: {
      value: (_vm.amsFiligModal.containerStuffingTelFax),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerStuffingTelFax", $$v)
      },
      expression: "amsFiligModal.containerStuffingTelFax"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Other Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Country of Manufracturer")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "countryOrigin",
      "name": "countryOrigin"
    },
    model: {
      value: (_vm.amsFiligModal.countryOrigin),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "countryOrigin", $$v)
      },
      expression: "amsFiligModal.countryOrigin"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Purchase Order(PO)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consopo",
      "name": "consopo"
    },
    model: {
      value: (_vm.amsFiligModal.consopo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "consopo", $$v)
      },
      expression: "amsFiligModal.consopo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("HTS Code")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "htsCode",
      "name": "htsCode"
    },
    model: {
      value: (_vm.amsFiligModal.htsCode),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "htsCode", $$v)
      },
      expression: "amsFiligModal.htsCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Shipping Information")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Carrier Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "CarrierName",
      "name": "CarrierName"
    },
    model: {
      value: (_vm.amsFiligModal.CarrierName),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "CarrierName", $$v)
      },
      expression: "amsFiligModal.CarrierName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booking No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "bookingNo",
      "name": "bookingNo"
    },
    model: {
      value: (_vm.amsFiligModal.bookingNo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "bookingNo", $$v)
      },
      expression: "amsFiligModal.bookingNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Carrier MBL SCAC Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblScacCode",
      "name": "mblScacCode"
    },
    model: {
      value: (_vm.amsFiligModal.mblScacCode),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "mblScacCode", $$v)
      },
      expression: "amsFiligModal.mblScacCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Master Bill of Landing")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "masterBillLanding",
      "name": "masterBillLanding"
    },
    model: {
      value: (_vm.amsFiligModal.masterBillLanding),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "masterBillLanding", $$v)
      },
      expression: "amsFiligModal.masterBillLanding"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("AMS SCAC Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "amsScacCode",
      "name": "amsScacCode"
    },
    model: {
      value: (_vm.amsFiligModal.amsScacCode),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "amsScacCode", $$v)
      },
      expression: "amsFiligModal.amsScacCode"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("AMS No./HBL No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "amsNo",
      "name": "amsNo"
    },
    model: {
      value: (_vm.amsFiligModal.amsNo),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "amsNo", $$v)
      },
      expression: "amsFiligModal.amsNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerNumber",
      "name": "containerNumber"
    },
    model: {
      value: (_vm.amsFiligModal.containerNumber),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "containerNumber", $$v)
      },
      expression: "amsFiligModal.containerNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Mother Vsl/Voy")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselVoy",
      "name": "vesselVoy"
    },
    model: {
      value: (_vm.amsFiligModal.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "vesselVoy", $$v)
      },
      expression: "amsFiligModal.vesselVoy"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("ETD Mother Vessel/LoadPort")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "etdloadPort",
      "name": "etdloadPort"
    },
    model: {
      value: (_vm.amsFiligModal.etdloadPort),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "etdloadPort", $$v)
      },
      expression: "amsFiligModal.etdloadPort"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("ETA at POD")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "etaPod",
      "name": "etaPod"
    },
    model: {
      value: (_vm.amsFiligModal.etaPod),
      callback: function($$v) {
        _vm.$set(_vm.amsFiligModal, "etaPod", $$v)
      },
      expression: "amsFiligModal.etaPod"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderSubmit"
    },
    on: {
      "click": _vm.addIsf
    }
  }, [_vm._v("Save &Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSubmit"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertSubmit",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopError",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d09910","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/normalIsfExport.vue
// module id = 2517
// module chunks = 0